import type { CSSProperties } from "react";
import { resolvePackVisual } from "@gaole/shared";
import { PackFoil } from "./PackFoil";

export type PackVisualProps = {
  id: string;
  name?: string;
  images?: string[] | null;
  foilLabel?: string | null;
  foilColor?: string | null;
  className?: string;
  style?: CSSProperties;
  sweep?: boolean;
};

/**
 * Renders full portrait pack artwork when `images[0]` exists; otherwise the CSS foil wrapper.
 */
export function PackVisual({
  id,
  name,
  images,
  foilLabel,
  foilColor,
  className = "",
  style,
  sweep = true,
}: PackVisualProps) {
  const visual = resolvePackVisual({ id, images, foilLabel, foilColor });

  if (visual.mode === "artwork" && visual.image) {
    return (
      <img
        src={visual.image}
        alt=""
        draggable={false}
        className={`select-none object-contain drop-shadow-[0_18px_40px_-18px_rgba(0,0,0,0.65)] ${className}`}
        style={style}
      />
    );
  }

  return (
    <PackFoil
      gradient={visual.gradient}
      image={null}
      name={name}
      sweep={sweep}
      className={className}
      style={style}
    />
  );
}
